import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const IMAGES = ['https://cdn.shopify.com/s/files/1/0980/5817/4834/files/ChatGPT_Image_2_jun_2026_15_41_05.png?width=1000', 'https://cdn.shopify.com/s/files/1/0980/5817/4834/files/ChatGPT_Image_2_jun_2026_15_30_48.png?width=1000', 'https://cdn.shopify.com/s/files/1/0980/5817/4834/files/ChatGPT_Image_2_jun_2026_16_18_17.png?width=1000', 'https://cdn.shopify.com/s/files/1/0980/5817/4834/files/ChatGPT_Image_2_jun_2026_16_13_55.png?width=1000'];
export function Showcase() {
  const [index, setIndex] = useState(0);
  const goTo = useCallback((i: number) => {
    setIndex((i % IMAGES.length + IMAGES.length) % IMAGES.length);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % IMAGES.length);
    }, 3000);
    return () => clearInterval(id);
  }, [index]);
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-t border-white/5" data-id="element-173">
      <div className="max-w-5xl mx-auto" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-175">
          <h2 className="text-4xl md:text-6xl text-white" data-id="element-176">
            MIRÁ LO QUE SE PUEDE{' '}
            <span className="text-brand-yellow" data-id="element-177">LOGRAR</span>
          </h2>
          <p className="text-xl text-gray-400 mt-4 font-medium" data-id="element-178">
            Mesadas • Baños • Cocinas • Locales • Escaleras
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-2xl overflow-hidden border border-white/10 box-glow" data-id="element-179">
          <div className="relative w-full aspect-[4/3] md:aspect-[16/9] bg-brand-gray" data-id="element-180">
            <AnimatePresence mode="sync" data-id="element-181">
              <motion.img key={index} src={IMAGES[index]} alt={`Resultado de microcemento ${index + 1}`} loading="lazy" decoding="async" width={1000} height={563} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.7,
              ease: 'easeInOut'
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-182" />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent pointer-events-none" data-id="element-183" />
          </div>

          {/* Arrows */}
          <button onClick={() => goTo(index - 1)} aria-label="Imagen anterior" className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-brand-yellow transition-colors" data-id="element-184">
            <ChevronLeft className="w-6 h-6" data-id="element-185" />
          </button>
          <button onClick={() => goTo(index + 1)} aria-label="Imagen siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-brand-yellow transition-colors" data-id="element-186">
            <ChevronRight className="w-6 h-6" data-id="element-187" />
          </button>

          {/* Dots */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-188">
            {IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la imagen ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-all duration-300 ${i === index ? 'w-8 bg-brand-yellow' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-189" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}